import { render, staticRenderFns } from "./UserShortlists.vue?vue&type=template&id=46594a45"
import script from "./UserShortlists.vue?vue&type=script&lang=js"
export * from "./UserShortlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports